import { render, staticRenderFns } from "./AbroadIpGoods.vue?vue&type=template&id=110c5a34&scoped=true&"
import script from "./AbroadIpGoods.vue?vue&type=script&lang=js&"
export * from "./AbroadIpGoods.vue?vue&type=script&lang=js&"
import style0 from "./AbroadIpGoods.vue?vue&type=style&index=0&id=110c5a34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110c5a34",
  null
  
)

export default component.exports